import React from "react";
import { Phone, Bell, ShieldCheck } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { VerificarTelefoneWhatsApp } from "./VerificarTelefoneWhatsApp";
import { Btn, Modal } from "./ui";

// Portão OBRIGATÓRIO de telefone. Aparece quando o usuário está logado mas
// ainda não tem um telefone CONFIRMADO (ex.: quem entrou pelo Google, que não
// passa pelo formulário de cadastro; ou quem se cadastrou digitando um número
// que ainda não provou ser seu). Bloqueia o app até confirmar — é por ele que
// chegam os avisos de pedido/pagamento/entrega (push + WhatsApp).
//
// Desde 09/09/2026 a confirmação é por código no WhatsApp do próprio número
// (regra do dono: "senão pessoas vão colocar números que não são delas"). Toda
// a mecânica mora em VerificarTelefoneWhatsApp — inclusive o caso do
// interruptor desligado, em que o número é salvo direto e a tela do código nem
// aparece.
//
// `Modal` único SEM onFechar: não dá pra dispensar (nem X, nem Esc, nem fundo).
export const ModalTelefoneObrigatorio = () => {
  const { user, setUser, logout } = useAuth();

  const aoConfirmar = (telefone) => {
    if (setUser) {
      setUser((prev) => ({ ...(prev || {}), telefone, telefone_verificado: true }));
    }
  };

  return (
    <Modal
      aberto
      titulo="Confirme seu WhatsApp"
      subtitulo="Falta só isso para você continuar. É por ele que avisamos você."
      icone={<Phone size={20} />}
      tom="orange"
      largura="max-w-md"
    >
      <div className="space-y-3">
        <div className="rounded-2xl border border-slate-200 bg-white p-3 space-y-2">
          <div className="flex items-center gap-2.5 text-[13px] text-slate-600">
            <Bell size={15} className="flex-shrink-0 text-slate-400" />
            <span>Avisos de pedido, pagamento e entrega chegam nele.</span>
          </div>
          <div className="flex items-center gap-2.5 text-[13px] text-slate-600">
            <ShieldCheck size={15} className="flex-shrink-0 text-slate-400" />
            <span>Confirmar evita que alguém cadastre um número que não é seu.</span>
          </div>
        </div>

        <VerificarTelefoneWhatsApp
          destino="conta"
          telefoneInicial={user?.telefone || ""}
          onConfirmado={aoConfirmar}
          textoBotao="Salvar e continuar"
        />

        <Btn full v="ghost" sz="sm" onClick={() => logout && logout()}>Sair da conta</Btn>
      </div>
    </Modal>
  );
};
